// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"157":"5aa5f5515eae25873767","192":"5a8d15313af681acbcf5","336":"f7b95a48817af9cdbe01","538":"45e1d2bf98b3c669cbdb","607":"237b88a9d186588f26ca"}[chunkId] + ".min.js";
};